class CustomerLegitimacyChecker extends HTMLElement {
  constructor() {
    super()

    this.honeyPotChecked = false
  }

  connectedCallback() {
    this.setupListeners()
  }
  
  setupListeners() {
    const checkbox = this.querySelector('[data-customer-legitimacy-checker-el="checkbox"]')
    const submitButton = this.querySelector('[data-customer-legitimacy-checker-el="submit"]')
    const form = this.closest('form');


    if(!checkbox || !submitButton || !form) {
      console.warn('CustomerLegitimacyChecker: Missing required elements.');
      return
    }

    checkbox.addEventListener('change', (event) => {
      this.honeyPotChecked = !!event.target.checked;
      submitButton.disabled = this.honeyPotChecked;
    });

    const observer = new MutationObserver(() => {
      if(checkbox.checked && !this.honeyPotChecked) {
        this.honeyPotChecked = true;
        submitButton.disabled = true;
      }
    });

    observer.observe(checkbox, { attributes: true });
  }
}

if (!customElements.get('customer-legitimacy-checker')) {
  customElements.define('customer-legitimacy-checker', CustomerLegitimacyChecker)
}